import { Component, Input, OnInit } from '@angular/core';
import { ExifOrientation } from '../../../../../app.constants';
import { DynamicProperty, DYNAMIC_PROPERTY } from '../../../../../_objects/dynamic-property';
import { Notifier, OfflineReportPreviewService } from '../../../../../_services/offline-report-preview.service';
import { UtilsService } from '../../../../../_services/_utils.service';
import { ReportSummary } from '../../../../models/report-preview/report-summary';
import { TableColumn, TemplateText } from '../../../../models/report-preview/report-template';
import { ReportComponentBase, TableData } from '../../../../models/report-preview/TableData';

@Component({
    selector: 'app-report-picture-container-offline',
    templateUrl: './report-picture.component.html',
    styleUrls: ['./report-picture.component.scss'],
    standalone: false
})
export class ReportPictureOfflineComponent implements OnInit {

  @Input() public pageKey: string;
  @Input() public pictureKey: string;
  @Input() public elementLocation: string;
  @Input() public tableData: TableData[];
  @Input() public isFirst = false;

  public reportPicture: ReportSummary;
  private notifier: Notifier;
  private inspectionSummaryLinkSize = 4;
  public summaryPageTableId: string = null;
  public rowSpans: number[][];
  public insertEmptyRows: number[];
  rowHeight = 0;
  sizeUnit: string;
  trHeight: number;

  readonly summaryLinkStyle = 'position: absolute; display: table; width: 50mm; height: 4mm; font-size: 4mm;';
  readonly anchorLinkStyle = 'color: -webkit-link; cursor: pointer; text-decoration: underline;';
  readonly reportPictureStyle = 'position: absolute; max-width: initial; max-height: initial; display: table;';
  readonly textInlineStyle = 'display: table-cell; word-break: normal; white-space: pre-wrap; overflow: hidden;';
  readonly reportPictureThStyle = 'text-align: center;';
  readonly beforeStyle = 'display: inline-block; vertical-align: middle;';

  get trBorderStyle() {
    let width: string = null;
    let style: string = null;
    let color: string = null;

    if (this.reportPicture.tableBorderStyle) {
      const borderStyles = this.reportPicture.tableBorderStyle.split(' ');
      if (borderStyles.length > 2) {
        width = borderStyles[0];
        style = borderStyles[1];
        color = borderStyles[2];
      } else {
        style = this.reportPicture.tableBorderStyle;
      }
    }

    if (!this.utils.isNullOrUndefined(this.reportPicture.tableBorderWidth)
      && this.reportPicture.tableBorderWidth !== '') {
      width = this.reportPicture.tableBorderWidth;
    }

    if (!this.utils.isNullOrUndefined(this.reportPicture.tableBorderColor)
      && this.reportPicture.tableBorderColor !== '') {
      color = this.reportPicture.tableBorderColor;
    }

    return `border-top-width: ${width}; `
      + `border-top-style: ${style}; `
      + `border-top-color: ${color}; `
      + `border-bottom-width: ${width}; `
      + `border-bottom-style: ${style}; `
      + `border-bottom-color: ${color}; `
      + `border-left-width: ${width}; `
      + `border-left-style: ${style}; `
      + `border-left-color: ${color}; `
      + `border-right-width: ${width}; `
      + `border-right-style: ${style}; `
      + `border-right-color: ${color}; `;
  }

  get tableDataStyle() {
    let width: string = null;
    let style: string = null;
    let color: string = null;

    if (this.reportPicture.tableBorderStyle) {
      const borderStyles = this.reportPicture.tableBorderStyle.split(' ');
      if (borderStyles.length > 2) {
        width = borderStyles[0];
        style = borderStyles[1];
        color = borderStyles[2];
      } else {
        style = this.reportPicture.tableBorderStyle;
      }
    }

    if (!this.utils.isNullOrUndefined(this.reportPicture.tableBorderWidth)
      && this.reportPicture.tableBorderWidth !== '') {
      width = this.reportPicture.tableBorderWidth;
    }

    if (!this.utils.isNullOrUndefined(this.reportPicture.tableBorderColor)
      && this.reportPicture.tableBorderColor !== '') {
      color = this.reportPicture.tableBorderColor;
    }

    let str = '';
    if (this.reportPicture.tableHasBorderTop) {
      str += `border-top-width: ${width}; `
        + `border-top-style: ${style}; `
        + `border-top-color: ${color}; `;
    }
    if (this.reportPicture.tableHasBorderBottom) {
      str += `border-bottom-width: ${width}; `
        + `border-bottom-style: ${style}; `
        + `border-bottom-color: ${color}; `;
    }
    if (this.reportPicture.tableHasBorderLeft) {
      str += `border-left-width: ${width}; `
        + `border-left-style: ${style}; `
        + `border-left-color: ${color}; `;
    }
    if (this.reportPicture.tableHasBorderRight) {
      str += `border-right-width: ${width}; `
        + `border-right-style: ${style}; `
        + `border-right-color: ${color}; `;
    }
    return str;
  }

  get tableWidthNum() {
    // return this.replaceNumForStr(this.reportPicture?.tableWidth);
    return this.reportPicture.getTableWidthNum();
  }

  get tableHeightNum() {
    // return this.replaceNumForStr(this.reportPicture?.tableHeight);
    return this.reportPicture.getTableHeightNum();
  }

  get tableHeaderHeightNum() {
    return this.replaceNumForStr(this.reportPicture?.tableHeaderHeight);
  }

  get tableHeight() {
    return this.reportPicture.getHeightNum('table');
  }

  get isSaveHtml(): boolean {
    return this.offlineReportPreviewService?.isSaveHtml;
  }

  constructor(
    public designService: OfflineReportPreviewService,
    private offlineReportPreviewService: OfflineReportPreviewService,
    private utils: UtilsService
  ) {
  }

  public ngOnInit() {
    this.notifier = {
      componentName: 'report-picture.component',
      ids: { pageId: this.pageKey, elementId: this.pictureKey }
    };
    this.reportPicture = this.designService.getSummary(this.pictureKey);
    this.reportPicture.tableColumns.forEach(column => {
      // 旧仕様のテンプレート補完対応
      if (column.textsInfo == null || column.textsInfo.length === 0) {
        column.textsInfo = [] as TemplateText[];
        column.texts.forEach(text => {
          column.textsInfo.push({
            text: text,
            type: 'dynamic',
            dynamicId: text
          } as TemplateText);
        });
      }
    });
    const tableDef = this.reportPicture.getTable();
    const tableHeaderHeight = tableDef.headerHeight;
    const pageBreakRow = this.reportPicture.defaultPageBreakRowCount;
    this.insertEmptyRows = new Array<number>((pageBreakRow - this.tableData.length) >= 0 ? pageBreakRow - this.tableData.length :0);
    this.rowHeight = (this.tableHeight - (tableHeaderHeight)) / pageBreakRow;
    this.sizeUnit = this.reportPicture.getSizeUnit() ?? 'mm';
    this.summaryPageTableId = this.designService.getPreviewPage(this.pageKey).backToSummaryId;
    this.rowSpans = this.designService.setSpans(this.tableData, this.reportPicture.tableColumns);
    this.trHeight = 0.0;
  }

  public getSummaryLinkTop(): string {
    const linkTop = this.reportPicture.getTitleTopNum() - 4;
    return [linkTop, 'mm'].join('');
  }

  getColumnWidth(column: TableColumn) {
    const tableWidth = Number(this.reportPicture.tableWidth);
    return tableWidth * (column.widthRatio / 100);
  }

  public getTableColumnVerticalStyle(columnHight: number, columnWidth: number) {
    // divを突き抜ける原因はheightを設定していないから。( height: {width}{sizeUnit}; )
    // しかし、heightをするとvertical-align: middle;が意味をなさなくなる。
    if (columnWidth / 2 > columnHight / 2) {
      return this.getTransformStyle((columnHight / 2) - (columnWidth / 2));
    }

    return this.getTransformStyle((columnWidth / 2) - (columnHight / 2));
  }

  public getTransformStyle(x: number) {
    const styles = ['transform', '-moz-transform', '-webkit-transform', '-o-transform', '-ms-transform'];
    return styles
      .map(style => style + `translateX(${x}${this.sizeUnit}) rotate(-90deg)`)
      .join(' ');
  }

  getTableRowStyle(columnNo: number) {
    if (this.reportPicture.tableHasRowBackground
      && this.reportPicture.tableRowBackgroundColor
      && columnNo % 2 === 1) {
      return `background-color: ${this.reportPicture.tableRowBackgroundColor};`;
    }

    return '';
  }

  replaceNumForStr(str: string) {
    if (!str) {
      return 0;
    }

    return Number(str.replace(/[^0-9]/g, ''));
  }

  getTableStyle() {

    const componentBase = new ReportComponentBase();
    componentBase.width = Number(this.reportPicture.tableWidth);
    componentBase.height = this.reportPicture.getHeightNum('table');

    return Object.assign(
      {
        'position': 'absolute',
        'top': this.reportPicture.tableTop,
        'left': this.reportPicture.tableLeft
      },
      componentBase.getSizeStyle(this.sizeUnit),
      {
        'white-space': 'normal',
        'border-spacing': `0${this.sizeUnit} 5${this.sizeUnit}`,
        'border-collapse': 'collapse',
        'table-layout': 'fixed',
        'overflow': 'hidden'
      }
    );
  }

  // getTextContent(column: TableColumn) {
  //   return this.reportPreviewService.getColumnHeaderContent(column, this.marks);
  // }

  public scrollToHashLink(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }

  public calcTrHeight() {
    const pageBreakRow = this.reportPicture.defaultPageBreakRowCount;
    return this.tableHeightNum != 0
      ? (this.tableHeightNum - this.tableHeaderHeightNum) / pageBreakRow
      : ((this.tableHeight - this.tableHeaderHeightNum) / pageBreakRow);
  }

  public calcTrHeightForColumn(tableColumn: TableColumn, tableData: TableData) {
    const pageBreakRow = this.reportPicture.defaultPageBreakRowCount;
    const baseTrHeight = this.calcTrHeight();
    tableColumn.textsInfo.forEach(_ => {
      const property = new DynamicProperty(_.dynamicId);
      if (property.key == DYNAMIC_PROPERTY.KEY.InspectionPicturesImage) {
        this.trHeight = 0.0;
        tableData.images.forEach(image => {
          let width = image.usedImageMode === 1
            ? image.modifiedWidth !== 0 ? image.modifiedWidth : this.tableWidthNum * (tableColumn.widthRatio / 100)
            : image.width !== 0 ? image.width : this.tableWidthNum * (tableColumn.widthRatio / 100);
          let height = image.usedImageMode === 1
            ? image.modifiedHeight !== 0 ? image.modifiedHeight : (this.tableHeight  - this.tableHeaderHeightNum) / pageBreakRow
            : image.height !== 0 ? image.height : (this.tableHeight  - this.tableHeaderHeightNum) / pageBreakRow;
          let maxHeight = baseTrHeight;

          // ExifOrientation
          switch (image.orientation) {
            case ExifOrientation.Default:
            case ExifOrientation.MirrorHorizontal:
            case ExifOrientation.Rotate180:
            case ExifOrientation.MirrorVertical:
            default:
              break;
            case ExifOrientation.MirrorHorizontalAndRotate270:
            case ExifOrientation.Rotate90:
            case ExifOrientation.MirrorHorizontalAndRotate90:
            case ExifOrientation.Rotate270:
              const tempWidth = width;
              width = height;
              height = tempWidth;
              break;
          }

          if (height > width) {
            maxHeight *= 2;
          }

          this.trHeight += maxHeight;
        });
      }
    });

    return this.trHeight === 0
      ? baseTrHeight
      : this.trHeight;
  }

  public isBackgroundColorStyle(tableColumn: TableColumn) {
    return tableColumn.textsInfo.some(_ => {
      const property = new DynamicProperty(_.dynamicId);
      return property.key == DYNAMIC_PROPERTY.KEY.InspectionSummaryClass || property.key == DYNAMIC_PROPERTY.KEY.InspectionPicturesClass;
    });
  }

  getMarginLeft(column: TableColumn) {
    const tableHeaderHeight = this.reportPicture.tableHeaderHeightNum;
    const width = this.tableWidthNum * (column.widthRatio / 100);
    if (width / 2 > tableHeaderHeight / 2) {
      const x = (tableHeaderHeight / 2) - (width / 2);
      return `${x}${this.sizeUnit}`;
    } else {
      const x = (width / 2) - (tableHeaderHeight / 2);
      return `${x}${this.sizeUnit}`;
    }
  }
}
